var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBetterDecisions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M256,16c118.097,0,213.832,95.736,213.832,213.832S374.096,443.664,256,443.664 S42.168,347.928,42.168,229.832l0,0C42.3,111.791,137.959,16.132,256,16 M256,0C129.067,0,26.168,102.899,26.168,229.832 S129.067,459.663,256,459.663s229.833-102.898,229.833-229.832l0,0C485.832,102.899,382.933,0,256,0z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E21B1B"
    },
    cx: 255.997,
    cy: 229.835,
    r: 108.941
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 255.997,
    cy: 229.835,
    r: 45.144
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 255.997,
    cy: 459.669,
    r: 48.336
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E21B1B"
    },
    d: "M256,415.328c24.486,0,44.335,19.849,44.335,44.335S280.486,503.999,256,503.999 c-24.486,0-44.335-19.849-44.335-44.336l0,0C211.695,435.19,231.527,415.359,256,415.328 M256,407.328 c-28.904,0-52.336,23.432-52.336,52.336C203.664,488.568,227.096,512,256,512s52.336-23.432,52.336-52.336 C308.335,430.759,284.904,407.328,256,407.328L256,407.328z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 55.894,
    cy: 120.893,
    r: 48.336
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E21B1B"
    },
    d: "M55.896,76.56c24.486,0,44.335,19.849,44.335,44.335s-19.849,44.335-44.335,44.335 S11.56,145.383,11.56,120.895l0,0C11.586,96.421,31.421,76.587,55.896,76.56 M55.896,68.56c-28.904,0-52.336,23.432-52.336,52.336 s23.432,52.336,52.336,52.336s52.336-23.432,52.336-52.336l0,0C108.232,91.992,84.801,68.56,55.896,68.56z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 456.101,
    cy: 120.893,
    r: 48.336
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E21B1B"
    },
    d: "M456.104,76.56c24.486,0,44.336,19.849,44.336,44.335s-19.849,44.335-44.336,44.335 c-24.486,0-44.335-19.849-44.335-44.335l0,0C411.795,96.421,431.629,76.587,456.104,76.56 M456.104,68.56 c-28.905,0-52.336,23.432-52.336,52.336s23.432,52.336,52.336,52.336c28.904,0,52.336-23.432,52.336-52.336 S485.008,68.56,456.104,68.56L456.104,68.56z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetterDecisions);
export default __webpack_public_path__ + "static/media/better-decisions.7c29d496d09547ca3ecf723d740b05c5.svg";
export { ForwardRef as ReactComponent };